import { z } from "zod";
export const mailingAddressSchema = z.object({
    name: z.string().optional(),
    addressStreet: z.string(),
    addressStreet2: z.string().optional(),
    addressCity: z.string(),
    addressRegion: z.string(),
    addressPostalCode: z.string(),
});
export const LogoStatus = {
    MISSING: "MISSING",
    DOES_NOT_MATCH_BRAND: "DOES NOT MATCH BRAND",
    IS_NOT_LEGIBLE: "IS NOT LEGIBLE",
    TAGLINE_NEEDS_TO_BE_REMOVED: "TAGLINE NEEDS TO BE REMOVED",
    PHONE_NUMBER_NEEDS_TO_BE_REMOVED: "PHONE NUMBER NEEDS TO BE REMOVED",
    IT_IS_TOO_SMALL_OR_NOT_LEGIBLE: "IT IS TOO SMALL OR NOT LEGIBLE",
    BACKGROUND_NEEDS_TO_BE_REMOVED: "BACKGROUND NEEDS TO BE REMOVED",
    APPROVED: "APPROVED",
};
export const candidateMetadataSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    displayName: z.string(),
    finalizedYears: z.array(z.number()).optional(),
    id: z.string(),
    mailingAddresses: z.array(mailingAddressSchema).optional(),
    name: z.string(),
    submitted: z.string().optional(),
    website: z.string().optional(),
}).catchall(z.any());
export const verificationAddressSchema = z.object({
    found_on: z.string(),
    address_street: z.string(),
    address_street2: z.string(),
    address_city: z.string(),
    address_region: z.string(),
    address_postal_code: z.string(),
});
//# sourceMappingURL=types.js.map